class ModifyData {
    constructor(nombreUsuario,nifCif,cliPagaRela,direccion,numCallePlaza,codPostal,localidad,provincia,telefono,fax,emailNotiPago) {
        this.nombreUsuario = nombreUsuario;
        this.nifCif = nifCif;
        this.cliPagaRela = cliPagaRela;
        this.direccion = direccion;
        this.numCallePlaza = numCallePlaza;
        this.codPostal = codPostal;
        this.localidad = localidad;
        this.provincia = provincia;
        this.telefono = telefono;
        this.fax = fax;
        this.emailNotiPago = emailNotiPago;
    }
}

export default ModifyData;